import API from "../api";
import qs from "query-string";
import { formatDate } from "@ufginsurance/ui-kit";

const modeAsUfgApi = "ufgapi";

const baseUIUrl = window.env.REACT_APP_BASEURL;

///
/// pdfs
/// -----

export const getPdf = (url, options = {}) => {
  const fullyQualifiedUrl = URL.parse(url);
  return fullyQualifiedUrl
    ? API.baseless().get(fullyQualifiedUrl, {
      ...options,
      responseType: "blob"
    })
    : API.base(modeAsUfgApi).get(url, { ...options, responseType: "blob" });
};

export const fetchPdfs = (url, formList) =>
  API.baseless().post(url, formList, {
    "Content-Type": "application/json",
    responseType: "blob"
  });

///
/// general
/// -----

export const getQuickLinks = userId =>
  API.policyholder(modeAsUfgApi).get(`/quick-links?user_id=${userId}`);

export const getHelpDeskInfo = () =>
  API.policyholder(modeAsUfgApi).get(`/help-desk`);

///
/// account
/// -----

export const fetchBillingActivityAccounts = () =>
  API.accounts(modeAsUfgApi).get("/accounts");

export const fetchClaimsAccountsData = () =>
  API.accounts(modeAsUfgApi).get("/accounts");

export const getBillingStatements = () =>
  API.accounts(modeAsUfgApi).get("/accounts/bills");

export const getAccountsWithAutoPolicies = () =>
  API.accounts(modeAsUfgApi).get("/accounts/auto-id-cards");

export const getAccountSummary = () => {
  return API.accounts(modeAsUfgApi).get("/accounts/summary");
};

//{account_id}/bill

export const fetchOpenClaimsData = (number, status) =>
  API.accounts(modeAsUfgApi).get(`/accounts/${number}/claims?status=${status}`);

export const fetchHistoryClaimsData = (number, status) =>
  API.accounts(modeAsUfgApi).get(`/accounts/${number}/claims?status=${status}`);

export const submitAddAccount = payload =>
  API.accounts(modeAsUfgApi).post("/accounts/registration", payload);

export const patchAcknowledgePaperlessTerms = number =>
  API.accounts(modeAsUfgApi).patch(
    `/accounts/${number}/acknowledgements?acknowledge_type=has_reviewed_paperless_terms`
  );

export const submitAccountReregistrationConfirmation = payload =>
  API.accounts(modeAsUfgApi).post("/accounts/registration/complete", payload);

export const fetchBillingAndAlertsAccounts = () =>
  API.accounts(modeAsUfgApi).get("/accounts/alerts");

export const submitBillingAndAlerts = payload =>
  API.accounts(modeAsUfgApi).post("/accounts/alerts", payload);

export const fetchGuidewireConversions = () =>
  API.accounts(modeAsUfgApi).get("/accounts/gw-conversions");

export const postGWConfirmation = () =>
  API.accounts(modeAsUfgApi).post(
    "/accounts/gw-conversions",
    JSON.stringify(""),
    {
      headers: { "Content-Type": "application/json" }
    }
  );

export const fetchCompanyNotifications = () =>
  API.policyholder(modeAsUfgApi).get("/notifications");

export const fetchMyAgent = () =>
  API.policyholder(modeAsUfgApi).get(`/agencies`);

///
/// billing
/// -----

export const fetchAutomaticPaymentAccounts = () =>
  API.billing(modeAsUfgApi).get("/billing/automatic-payments");

export const fetchPaymentVendorRoute = (accountNumber, returnUrl) =>
  API.billing(modeAsUfgApi).get(
    `/billing/automatic-payments/enrollment/${accountNumber}?cancellation_url=${returnUrl || baseUIUrl
    }`
  );

export const fetchInstallmentScheduleAccounts = () =>
  API.billing(modeAsUfgApi).get("/billing/installment-schedules");

export const fetchInstallmentScheduleAccountDetails = accountNumber =>
  API.billing(modeAsUfgApi).get(
    `/billing/installment-schedules/${accountNumber}`
  );

export const fetchBillingActivityDetails = (
  accountNumber,
  activity_date_from,
  activity_date_to
) => {
  let queryString;
  if (activity_date_from && activity_date_to) {
    queryString = qs.stringify({
      activity_date_from: formatDate(activity_date_from, "YYYY-MM-DD"),
      activity_date_to: formatDate(activity_date_to, "YYYY-MM-DD")
    });
    return API.billing(modeAsUfgApi).get(
      `billing/activity/${accountNumber}?${queryString}`
    );
  }
  return API.billing(modeAsUfgApi).get(`billing/activity/${accountNumber}`);
};

export const fetchPolicyBalanceRemainingDetails = accountNumber =>
  API.billing(modeAsUfgApi).get(
    `/billing/activity/${accountNumber}/unpaid-policy`
  );

///
/// policies
/// -----

export const fetchMyPoliciesList = () =>
  API.policies(modeAsUfgApi).get("/policies");

export const fetchPolicyActivity = policyNumber =>
  API.policies(modeAsUfgApi).get(`/policies/${policyNumber}/activity`);

export const fetchPolicyDecs = (policyNumber, company_branch, effective_date) =>
  API.policies(modeAsUfgApi).get(
    `/policies/${policyNumber}/coverage-options?effective_date=${effective_date}&company_branch=${company_branch}`
  );

export const fetchPolicyForms = (policyNumber, coverageOption, paramsString) =>
  API.policies(modeAsUfgApi).get(
    `/policies/${policyNumber}/coverage-forms/${coverageOption}${paramsString}`
  );

export const submitNickname = (policyNumber, payload) =>
  API.policies(modeAsUfgApi).post(
    `/policies/${policyNumber}/nickname`,
    payload
  );

export const fetchCancellationNotice = policyNumber =>
  API.policies(modeAsUfgApi).get(
    `/policies/${policyNumber}/cancellation-notice`,
    {
      responseType: "blob"
    }
  );

///
/// profile
/// -----

export const getUserProfile = () => API.profile(modeAsUfgApi).get("/profile");

export const submitEditProfile = userProfile =>
  API.profile(modeAsUfgApi).put("/profile", userProfile);

export const submitChangePassword = payload =>
  API.profile(modeAsUfgApi).put("/profile/password", payload);

export const fetchSecurityQuestions = () =>
  API.profile(modeAsUfgApi).get(`/profile/security-questions`);

///
/// feedback
/// -----
export const postFeedback = body =>
  API.policyholder(modeAsUfgApi).post("/feedback", body);

///
/// Policy Holder .NET policyHolderXAPI
/// ------
export const getDownIndicator = system =>
  API.policyholder(modeAsUfgApi).get(`/availability/systems?systems=${system}`);
